module.exports = globalThis.FitAddon